exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-fedf5ffa] {\n    width: 100%;\n}\n.panel2[data-v-fedf5ffa], .panel21[data-v-fedf5ffa] {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n*[data-v-fedf5ffa] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.list-block[data-v-fedf5ffa] {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n/*\nul {\n  padding-left: initial;\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fedf5ffa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/contacts/CMEditContact.vue
// module id = 1180
// module chunks = 2